import React from "react";
import { useTranslation } from "react-i18next";
import { useVerifyAccount } from "./useVerifyAccount";
import { useStyles } from "./verify-account.styles";

const VerifyAccount: React.FC = () => {
  const { t } = useTranslation();
  const classes = useStyles();

  const { status, message, onContinueToLogin } = useVerifyAccount();

  return (
    <div className={classes.container}>
      <span className={classes.title}>{t("auth.verifyAccountTitle")}</span>
      <div className={classes.card}>
        <span className={`h6-regular ${classes.message}`}>{message}</span>
        <button
          type="button"
          className={classes.continueButton}
          disabled={status === "loading"}
          onClick={onContinueToLogin}
        >
          {t("auth.continueToLogin")}
        </button>
      </div>
    </div>
  );
};

export default VerifyAccount;
